import { TemplateGoal, Template } from "../bundles/entities.bundle";

export class TemplateDetails {
    constructor() {
        this.template = new Template();
        this.templateGoals = new Array<TemplateGoal>();
    }

    template: Template;
    templateGoals: Array<TemplateGoal>;
}